module.exports = __webpack_public_path__ + "static/media/plus.389c820b.svg";